module.exports = __webpack_public_path__ + "img/m-csmar-server.01b5ad14.png";